import { Component, inject, Input, OnInit, Type } from '@angular/core';
import { BaseControl, FormGroupErrorMessageComponent, FormNoData, LoadingPanelService, TypeChecker, Utils } from 'lib-base';
import { ControlOptionsComponent } from './control-options.component';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormularioService } from '../../../../services/database/formulario.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sub-formulario-select',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, DropdownModule, ButtonModule, FormGroupErrorMessageComponent],
  template: `
  <form [formGroup]="form">
    <main class="grid formgrid p-fluid">
      <div class="field col-12">
        <label for="tablaDinamicaConfigId" class="ml-3">
          {{'fields.tipo-tramite-actividad.subformularioSelect' | translate}}
          <span style="color: red">*</span>
        </label>
        <div class="flex gap-1 justify-content-start">
          <p-dropdown [options]="formularios" formControlName="formulario" appendTo="body"
            optionLabel="nombre" [filter]="true" (onChange)="onChange($event)"
            [filter]="true"
            autoWidth="false" class="flex-grow-1">
          </p-dropdown>
          <button pButton type="button" (click)="refreshReference()" icon="pi pi-refresh"
            class="p-button-success" 
            [disabled]="disableBtns">
          </button>
          <button pButton type="button" (click)="openForm()" icon="pi pi-search"
            class="p-button-help"
            [disabled]="disableBtns">
          </button>
        </div>
        <ng-container *ngIf="form.get('formulario')?.invalid && form.get('formulario')?.dirty">
          <app-form-group-error-message [control]="form.get('formulario')"></app-form-group-error-message>
        </ng-container>
      </div>
    </main>
  </form>
  `
})
export class SubFormularioSelectComponent implements OnInit {


  @Input() control?: BaseControl<any>;
  form !: FormGroup;
  trans: any = {};
  formularios !: FormNoData[];
  disableBtns: boolean = true;

  private parent: ControlOptionsComponent = inject(ControlOptionsComponent);

  constructor(private readonly _ms: MessageService, private readonly _fs: FormularioService, private readonly _t: TranslateService,
    private readonly _fb: FormBuilder, private readonly _lps: LoadingPanelService
  ) {
    this.getFormularios();
    this.formConfig();
  }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      completeCamposRequeridos: this._t.get('msg.completeCamposRequeridos'),
      advertencia: this._t.get('common.advertencia'),
    }));
  }

  getFormularios() {
    this._lps.show(true);
    this._fs.getFormsNoData().subscribe({
      next: (forms: FormNoData[]) => {
        if (TypeChecker.isSubFormulario(this.control)) {
          this.formularios = forms;
          this.setUp();
        }
        this._lps.hide();
      }
    });

  }

  setUp() {
    if (TypeChecker.isSubFormulario(this.control)) {
      const formId = this.control.formId;
      if (!formId) return;
      const formulario = this.formularios.find(f => f.id === formId) ?? null;
      this.form.get('formulario')?.setValue(formulario);
      this.disableBtns = false;
    }
  }

  private formConfig() {
    this.form = this._fb.group({
      formulario: [null, [Validators.required]]
    });
  }

  onChange($event: DropdownChangeEvent) {
    this.parent.applySubFormularioSelect(this.form.value.formulario);
    this.disableBtns = false;
  }

  refreshReference() {
    this.parent.applySubFormularioSelect(this.form.value.formulario);
  }

  openForm() {
    const formulario = this.form.value.formulario;
    if (!formulario) return;
    const url = `#/configuracion/formulario/edit/${this.form.value.formulario.id}`
    window.open(url, '_blank');
  }
}
